import { cssVar } from '@cad-arc';

/**
 * Colours for the parts of the Sensor Event Card that Arc has no component for — the severity dot
 * and the clip — mapped onto Arc tokens.
 *
 * Deliberately not a theme. The drawer and every control in it use Arc as it comes: the design
 * handoff styles those its own way, and where it disagrees with Arc, Arc wins. Only content with
 * no Arc equivalent gets colours here.
 */

type ArcToken = Parameters<typeof cssVar>[0];

/** An Arc colour at an opacity. Arc's raw ramps are solid hex, so alpha has to be mixed in. */
function tint(token: ArcToken, percent: number): string {
    return `color-mix(in srgb, ${cssVar(token)} ${percent}%, transparent)`;
}

export const sensorEventsPalette = {
    /** Every alert type observed so far is a detection. */
    severityDetection: cssVar('arc.colors.raw.yellow.300'),

    clipBackground: cssVar('arc.colors.surface.background'),
    /** The clip area when the alert carries no image. */
    noClipBorder: tint('arc.colors.negative.default', 35),
    noClipText: cssVar('arc.colors.negative.default'),
    /** Behind the LOOP / PAUSED chip, so it reads over any frame. */
    overlayBackground: tint('arc.colors.raw.gray.900', 82),
} as const;
